import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BasicSnackbarComponent } from '../../basic-snackbar/basic-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class GlobalNotification {
  constructor(
    private snackBar: MatSnackBar) { }

public showSnackBar(title, message, type)
  {
    var style = "snb-success";
    if(type == "error")
    {
      style = "snb-error";
    }
    else if(type == "warning")
    {
      style = "snb-warning";
    }

    this.snackBar.openFromComponent(BasicSnackbarComponent, {
      data: {
        title: title,
        message: message
      },
      duration: 10000,
      panelClass: [style],
      verticalPosition: "top",
      horizontalPosition: "center"
    });
  }

}
